import { defaults } from '@ohif/core';

export default {
  'ohif.hotkeyBindings': defaults.hotkeyBindings,
};
